import React, { Component } from "react";
import pdfjsLib from "pdfjs-dist";
import { Modal, Button } from "react-bootstrap";
import "./PdfThumbnail.css";
import PDFViewer from "./PDFViewer";

class PdfThumbnail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgData: null,
      loading: true,
      error: null,
      showModal: false,
    };
  }

  componentDidMount() {
    this.renderThumbnail(
      this.props.url,
      this.props.page || 1,
      this.props.scale || 0.5
    );
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.url !== this.props.url ||
      prevProps.page !== this.props.page ||
      prevProps.scale !== this.props.scale
    ) {
      this.renderThumbnail(
        this.props.url,
        this.props.page || 1,
        this.props.scale || 0.5
      );
    }
  }

  renderThumbnail(url, pageNum, scale) {
    this.setState({ loading: true, error: null });

    pdfjsLib
      .getDocument(url)
      .then((pdf) => pdf.getPage(pageNum))
      .then((page) => {
        const viewport = page.getViewport(scale);
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");

        canvas.width = viewport.width;
        canvas.height = viewport.height;

        const renderContext = { canvasContext: context, viewport: viewport };

        return page.render(renderContext).then(() => {
          const imgData = canvas.toDataURL("image/png");
          this.setState({ imgData, loading: false });
        });
      })
      .catch((err) => {
        this.setState({ error: err.message, loading: false });
      });
  }

  handleOpen = () => this.setState({ showModal: true });
  handleClose = () => this.setState({ showModal: false });

  render() {
    const { imgData, loading, error, showModal } = this.state;
    const { alt, maxWidth, url, name, onRemove } = this.props; // ⬅️ get remove handler

    if (loading) return <div>Loading preview…</div>;
    if (error) return <div className="pdf-thumbnail-error">Error: {error}</div>;

    return (
      <div
        className="pdf-thumbnail-wrapper"
        style={{ maxWidth: maxWidth || "200px" }}
      >
        <div className="pdf-thumbnail-img-container">
          <img
            src={imgData}
            alt={alt || "PDF Preview"}
            className="pdf-thumbnail-img"
          />
          {/* Hover overlay */}
          <div className="pdf-thumbnail-overlay">
            <div className="pdf-thumbnail-text">
              <div>{this.props.language || ""}</div>
            </div>
          </div>
        </div>
        {/* Eye icon (top-right) */}
        <div
          className="pdf-thumbnail-eye"
          onClick={(e) => {
            e.stopPropagation();
            this.handleOpen();
          }}
        >
          <i className="fa fa-eye" aria-hidden="true"></i>
        </div>

        {/* Remove icon (top-left) */}
        {onRemove && <div
          className="pdf-thumbnail-remove"
          onClick={(e) => {
            e.stopPropagation();
            onRemove(); // call parent handler
          }}
        >
          <i className="fa fa-trash" aria-hidden="true"></i>
        </div>}

        {/* Modal */}
        <Modal
          show={showModal}
          onHide={this.handleClose}
          bsSize="large"
          aria-labelledby="pdf-preview-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title id="pdf-preview-modal">
              {name || "PDF Viewer"}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <PDFViewer url={url} />
          </Modal.Body>

          <Modal.Footer>
            <Button onClick={this.handleClose}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default PdfThumbnail;
